import "./StudentsTrainersPages.scss";
import AddIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "./../../../../Assets/edit-icon.svg";
import DeleteIcon from "./../../../../Assets/delete-icon.svg";
import AttentionIcon from "./../../../../Assets/attention-icon.svg";
import CloseIcon from "./../../../../Assets/close-icon.svg";
import ViewIcon from "./../../../../Assets/details-icon.svg";
import { Modal, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../Components/Button/Button";
import { StudentsTrainersPagesColumns } from "../../../../SourceData";

import newRequest from "../../../../Utils/newRequest";
import { showErrorMessage } from "../../../../Utils/showErrorMessage";
import Loader from "../../../../Components/Loader/Loader";
import { message } from "antd";

const StudentsTrainersPages = () => {
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [rowId, setRowId] = useState("");
  const [selectedRowsIds, setSelectedRowsIds] = useState([]);
  const isTrainer = location?.pathname?.includes("/trainer");

  useEffect(() => {
    getPages();
  }, [isTrainer]);

  const getPages = async () => {
    setLoading(true);
    try {
      const res = await newRequest.get(
        `/intro_pages?type=${isTrainer ? "trainer" : "student"}`
      );
      setPages(res?.data?.data);
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleMultiDelete = async () => {
    if (selectedRowsIds.length === 0) {
      return message.warning("من فضك قم بتحديد الصفوف التي تريد حذفها اولاً");
    }
    setLoading(true);
    try {
      for (const questionId of selectedRowsIds) {
        await newRequest.delete(`/intro_pages/${questionId}`);
      }
      await getPages();
      setSelectedRowsIds([]);
      message.success("تم الحذف بنجاح");
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setOpenMessage(false);
    try {
      await newRequest.delete(`/intro_pages/${rowId}`);
      await getPages();
      setRowId("");
      message.success("تم الحذف بنجاح");
    } catch (error) {
      showErrorMessage(error);
    } finally {
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "الإجراءات",
      width: 280,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action" style={{ display: "flex" }}>
            {/* <div
              className="cell-btn"
              onClick={() => {
                navigate("/sub-departments/view", { state: params?.row });
              }}
            >
              <img src={ViewIcon} alt="" />
            </div> */}

            <div
              className="cell-btn"
              onClick={() => {
                navigate(
                  `/profile-pages/${isTrainer ? "trainers" : "students"}/edit`,
                  { state: params?.row }
                );
              }}
            >
              <img src={EditIcon} alt="" />
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                setOpenMessage(true);
                setRowId(params?.row?.id);
              }}
            >
              <img src={DeleteIcon} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="common-page">
      <div className="container">
        <div className="spcial-header">
          <h4 className="title">
            الصفحات التعريفية ( {isTrainer ? "المدرب" : "الطالب"} )
          </h4>
          <div className="actions-container">
            <Button
              text={"اضافة صفحة"}
              size={isMobile ? "full" : "fit"}
              variant={"fill"}
              icon={<AddIcon />}
              path={`/profile-pages/${
                isTrainer ? "trainers" : "students"
              }/create`}
              isMobile=""
            />

            <Button
              text={"حذف متعدد"}
              size={isMobile ? "full" : "small"}
              variant={"outlined"}
              onClick={handleMultiDelete}
            />
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div className="data-grid">
            <DataGrid
              sx={{ minHeight: 600 }}
              columns={StudentsTrainersPagesColumns.concat(actionColumn)}
              rows={pages.map((row, index) => {
                return { ...row, index: index + 1 };
              })}
              disableDensitySelector
              disableRowSelectionOnClick
              disableVirtualization
              initialState={{
                ...pages.initialState,
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              pageSizeOptions={[10, 25, 50]}
              rowHeight={60}
              checkboxSelection
              onRowSelectionModelChange={(newRowSelectionModel) => {
                setSelectedRowsIds(newRowSelectionModel);
              }}
              rowSelectionModel={selectedRowsIds}
            />
          </div>
        )}
      </div>

      {/* Message Modal */}
      <Modal
        open={openMessage}
        onClose={() => {
          setOpenMessage(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="message-modal"
      >
        <div className="container">
          <div
            className="header"
            onClick={() => {
              setOpenMessage(false);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
          <div className="body">
            <img src={AttentionIcon} alt="" />
            <h2>انتبة</h2>
            <h5>هل انت متاكد من حذف هذه الصفحة من</h5>
            <h6>الصفحات التعريفية</h6>
          </div>
          <div className="footer">
            <button className="action-btn" onClick={handleDelete}>
              حذف
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default StudentsTrainersPages;
